import React from 'react'
import {ChatMessage, SystemMessageUtils} from 'yougile-model'
import {ChatSettings} from '@extensions/chat-settings'
import {LazyMessagePlaceholder} from './lazy-message-placeholder'
import {SystemMessage} from './system-message'
import {UserMessage} from './user-message'

type Props = {
  message: ChatMessage
  className?: string
  fullView?: boolean
  hideAvatar?: boolean
  animateShow?: boolean
  lastImage?: boolean
}

export const MessageNew = ({
  message,
  className,
  fullView,
  hideAvatar,
  animateShow,
  lastImage
}: Props) => {
  ChatSettings.useUpdateEffect()

  if (SystemMessageUtils.isLazyPlaceholder(message)) {
    return <LazyMessagePlaceholder message={message} />
  }

  if (SystemMessageUtils.isSystemMessage(message)) {
    return (
      <SystemMessage
        message={message}
        className={className}
        animateShow={animateShow}
      />
    )
  }

  return (
    <UserMessage
      msg={message}
      className={className}
      fullView={fullView}
      hideAvatar={hideAvatar}
      animateShow={animateShow}
      lastImage={lastImage}
    />
  )
}
